import WorkspaceSectionLayout from '../../components/WorkspaceSectionLayout';
import { salesSubtabs } from '../../navigation';

const SalesLayout = () => (
  <WorkspaceSectionLayout
    eyebrow="Sales"
    title="Payments & till"
    description="Deposits from your booking link, balances taken at the till, and payouts to the account you connected."
    ariaLabel="Sales sections"
    tabs={salesSubtabs}
  />
);

export default SalesLayout;
